import React from "react";
import { withStyles, Button, CircularProgress } from "@material-ui/core";
import Select from "../../../../common/StyledSelect";
import { compose } from "recompose";
import { withSnackbar } from "notistack";
import formStyles from "../../formStyles";
import { isEqual } from "lodash/lang";
import WithDrawer from "../../../Dispatch/Common/Drawer/WithDrawer";
import { postData } from "../../../../../api/componentAPIs";

class UpdateForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTerminalData:
        this.props.selectedTerminalData || this.getDefaultTerminalInfo(),
      errorInfo: {},
    };
  }

  componentDidUpdate(prevProps) {
    if (
      !isEqual(this.props.selectedTerminalData, prevProps.selectedTerminalData)
    ) {
      this.setState({
        selectedTerminalData:
          this.props.selectedTerminalData || this.getDefaultTerminalInfo(),
        errorInfo: {},
      });
    }
  }

  getDefaultTerminalInfo() {
    return {
      terminalCode: null,
      feederTerminalCode: [],
    };
  }

  handleChange = (name) => (value) => {
    if (name === "terminalCode") {
      value = value && value.label;
    } else if (name === "feederTerminalCode") {
      value = value && value.map((x) => x.label);
    }
    this.setState((state) => ({
      selectedTerminalData: {
        ...state.selectedTerminalData,
        [name]: value,
      },
      errorInfo: {
        ...state.errorInfo,
        [name]: this.getFieldError(name, value),
      },
    }));
    if (name === "terminalCode" && this.props.isCreateTerminalFlow) {
      this.replaceWithAvailableFeederTerminals(value);
    }
  };

  replaceWithAvailableFeederTerminals = (terminalCode) => {
    const feederTerminalCode =
      this.props.feederTerminalData.find(
        (feederTerminal) => feederTerminal.terminalCode === terminalCode
      )?.feederTerminalCode ?? [];
    this.setState((prevState) => ({
      ...prevState,
      selectedTerminalData: {
        ...prevState.selectedTerminalData,
        feederTerminalCode,
      },
    }));

    if (feederTerminalCode.length) {
      this.props.updateCreateTerminalToUpdateTerminal();
    }
  };

  getFieldError = (field, value) => {
    switch (field) {
      case "terminalCode":
        return value ? null : `* Required`;
      case "feederTerminalCode":
        if (!this.props.isCreateTerminalFlow) {
          return null;
        }
        return value?.length ? null : "* Required";
      default:
        return null;
    }
  };

  getErrorInfo = () => {
    let errorInfo = {};
    Object.keys(this.state.selectedTerminalData).forEach((fieldName) => {
      errorInfo[fieldName] = this.getFieldError(
        fieldName,
        this.state.selectedTerminalData[fieldName]
      );
    });
    this.setState({
      errorInfo,
    });
    return errorInfo;
  };

  updateTerminal = () => {
    const errorInfo = this.getErrorInfo();
    const error = Object.values(errorInfo).filter((value) => value).length;
    if (!error) {
      this.onCreateOrUpdateTerminal();
    }
  };

  onCreateOrUpdateTerminal = () => {
    const { terminalCode, feederTerminalCode } =
      this.state.selectedTerminalData;
    const { isCreateTerminalFlow } = this.props;
    const requestParams = {
      terminalCode,
      feederTerminals: feederTerminalCode ?? [],
    };
    this.props.updateModel({
      selectedTerminal: terminalCode,
      terminalUpdateInProgress: true,
    });
    postData("UpdateFeederTerminal", requestParams).then(
      (response) => {
        if (Math.trunc(response.status / 100) === 2) {
          if (isCreateTerminalFlow) {
            this.props.enqueueSnackbar(
              `Created feeder terminals for ${terminalCode}`,
              {
                variant: "success",
              }
            );
          } else {
            this.props.enqueueSnackbar(`Updated terminal ${terminalCode}`, {
              variant: "success",
            });
          }
          this.props.updateModel({
            selectedTerminal: terminalCode,
            terminalUpdateInProgress: false,
            showTerminalUpdatePanel: false,
          });
        } else {
          if (isCreateTerminalFlow) {
            this.props.enqueueSnackbar(
              `Error creating feeder terminals for ${terminalCode}`,
              { variant: "error" }
            );
          } else {
            this.props.enqueueSnackbar(
              `Error updating terminal ${terminalCode}`,
              {
                variant: "error",
              }
            );
          }
          this.props.updateModel({
            selectedTerminal: terminalCode,
            terminalUpdateInProgress: false,
          });
        }
      },
      (_error) => {
        if (isCreateTerminalFlow) {
          this.props.enqueueSnackbar(
            `Error creating feeder terminals for ${terminalCode}`,
            { variant: "error" }
          );
        } else {
          this.props.enqueueSnackbar(
            `Error updating terminal ${terminalCode}`,
            {
              variant: "error",
            }
          );
        }
        this.props.updateModel({
          selectedTerminal: terminalCode,
          terminalUpdateInProgress: false,
        });
      }
    );
  };

  render() {
    const { classes, isCreateTerminalFlow, terminalUpdateInProgress } =
      this.props;
    const {
      selectedTerminalData: { terminalCode, feederTerminalCode },
      errorInfo,
    } = this.state;
    return (
      <>
        <div className={classes.feederTerminalTitle}>
          {isCreateTerminalFlow
            ? "Add Feeder Terminals"
            : "Update Feeder Terminals"}
        </div>
        <div className={classes.feederTerminalContainer}>
          <form className={classes.form} noValidate>
            <div className={classes.flexRow}>
              <Select
                textFieldProps={{
                  id: "terminalCode",
                  label: "Terminal",
                  variant: "outlined",
                  helperText: errorInfo.terminalCode,
                }}
                value={terminalCode}
                error={Boolean(errorInfo.terminalCode)}
                onChange={this.handleChange("terminalCode")}
                data={this.props.terminalOptions?.filter(
                  (option) => option.isTerminalLocation
                )}
              />
            </div>
            <div className={classes.flexRow}>
              <Select
                textFieldProps={{
                  id: "feederTerminalCode",
                  label: "Feeder Terminals",
                  variant: "outlined",
                  helperText: errorInfo.feederTerminalCode,
                }}
                value={feederTerminalCode?.length ? feederTerminalCode : ""}
                error={Boolean(errorInfo.feederTerminalCode)}
                isMulti
                onChange={this.handleChange("feederTerminalCode")}
                data={this.props.terminalOptions?.filter(
                  (option) => option.label !== terminalCode
                )} // remove default terminal from selectable option
              />
            </div>
          </form>
          <div className={classes.actionContainer}>
            <Button
              variant="outlined"
              color="primary"
              size="medium"
              onClick={this.props.onClose}
              classes={{ root: classes.actionButton }}
              id="closeButton"
            >
              Close
            </Button>
            <Button
              variant="contained"
              color="primary"
              size="medium"
              type="submit"
              onClick={this.updateTerminal}
              classes={{
                root: classes.actionButton,
                disabled: classes.actionButtonDisabled,
              }}
              id={
                isCreateTerminalFlow
                  ? "addFeederTerminals"
                  : "updateFeederTerminals"
              }
            >
              {terminalUpdateInProgress ? (
                <CircularProgress
                  size={16}
                  classes={{ root: classes.circularProgress }}
                />
              ) : isCreateTerminalFlow ? (
                "Add"
              ) : (
                "Update"
              )}
            </Button>
          </div>
        </div>
      </>
    );
  }
}

export default compose(
  withStyles(formStyles),
  withSnackbar,
  WithDrawer
)(UpdateForm);
